import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";

import Lang from "../helpers/language.json";
import { CAFE24_URL } from "../constants";

const extractCafe24RedirectUrl = (fullUrl) => {
  const toShopBase = (urlStr) => {
    try {
      const u = new URL(urlStr);
      const [first] = u.pathname.split("/").filter(Boolean);
      return u.origin + (first === "shop2" ? "/shop2" : "");
    } catch {
      return null;
    }
  };

  try {
    const outer = new URL(fullUrl);
    const top = outer.searchParams.get("redirect_uri");
    if (top) return toShopBase(decodeURIComponent(top));

    const cont = outer.searchParams.get("continue");
    if (cont) {
      const inner = decodeURIComponent(cont);
      const innerRedirect = new URL(inner).searchParams.get("redirect_uri");
      if (innerRedirect) return toShopBase(decodeURIComponent(innerRedirect));
    }

    return null;
  } catch {
    return null;
  }
};

const LangCxt = createContext(null);
export const useLang = () => useContext(LangCxt);

export default function LangProvider({ children }) {
  const [lang, setLang] = useState("ko");
  const [cafe24RedirectUrl, setCafe24RedirectUrl] = useState(null);

  const refresh = useCallback(async (language) => {
    try {
      const url = extractCafe24RedirectUrl(window.location.href);
      setCafe24RedirectUrl(url || CAFE24_URL);

      const subdomainLang = url
        ? ["en", "jp"].find((l) => url.startsWith(`https://${l}`)) ?? (url.includes("/shop2") ? "en" : null)
        : null;
      const nextLang = language || subdomainLang || "ko";
      setLang(nextLang);
    } catch {}
  }, []);

  const i18n = useCallback(
    (key) => {
      return Lang[key]?.[lang] ?? key;
    },
    [lang]
  );

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({
      refresh,
      i18n,
      setLang,
      lang,
      cafe24RedirectUrl,
      setCafe24RedirectUrl,
    }),
    [refresh, i18n, lang, cafe24RedirectUrl]
  );

  return <LangCxt.Provider value={value}>{children}</LangCxt.Provider>;
}
